"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShippingSizes;
(function (ShippingSizes) {
    ShippingSizes["xs"] = "xs";
    ShippingSizes["s"] = "s";
    ShippingSizes["m"] = "m";
    ShippingSizes["l"] = "l";
    ShippingSizes["xl"] = "xl";
    ShippingSizes["xxl"] = "xxl";
})(ShippingSizes = exports.ShippingSizes || (exports.ShippingSizes = {}));
var ShippingOptionNames;
(function (ShippingOptionNames) {
    ShippingOptionNames["pickAtSeller"] = "pickAtSeller";
    ShippingOptionNames["sellerDelivery"] = "sellerDelivery";
    ShippingOptionNames["pickup"] = "pickup";
    ShippingOptionNames["youzdDelivery"] = "youzdDelivery";
})(ShippingOptionNames = exports.ShippingOptionNames || (exports.ShippingOptionNames = {}));
exports.shippingSizeLimits = [
    {
        size: 'xs',
        maxDepth: 0.4,
        maxWidth: 0.33,
        maxHeight: 0.05
    },
    {
        size: 's',
        maxDepth: 0.44,
        maxWidth: 0.27,
        maxHeight: 0.18
    },
    {
        size: 'm',
        maxDepth: 0.55,
        maxWidth: 0.35,
        maxHeight: 0.30
    },
    {
        size: 'l',
        maxDepth: 1.5,
        maxWidth: 0.85,
        maxHeight: 0.6
    },
    {
        size: 'xl',
        maxDepth: 1.67,
        maxWidth: 1.22,
        maxHeight: 1.16
    },
    {
        size: 'xxl',
        maxDepth: 4,
        maxWidth: 4,
        maxHeight: 2
    },
];
exports.sizesEligibleToPickup = ['xs', 's', 'm', 'l'];
exports.youzdDeliveryPrices = [
    {
        size: 'l',
        sellerCost: 10,
        buyerCost: 19
    },
    {
        size: 'xl',
        sellerCost: 20,
        buyerCost: 29
    },
    {
        size: 'xxl',
        sellerCost: 30,
        buyerCost: 39
    },
];
//# sourceMappingURL=index.js.map